module.exports = __webpack_public_path__ + "img/p3.02ee3652.gif";